<template>
    <div class="page">
        <div class="title">congratulations!<span>创建成功✅</span></div>
        <div class="manuscriptId">稿件ID：{{manuscriptId}}</div>
        <div class="manuscriptId">稿件标题：{{manuscriptTitle}}</div>
        <div style="margin-top: 50px;">
          <span class="manuscriptId">专属链接：</span>
          <!-- <el-link style="font-size: 20px;" type="primary">{{manuscripturl}}</el-link> -->
          <!-- <span style="text-decoration:underline;color:#6395f0;"></span> -->
          <span style="font-weight: 0;font-size: 18px;"><a  :href="manuscripturl">{{manuscripturl}}</a></span>
          
        </div>
        <div class="shuomin"> <span class="manuscriptId">NOTE：</span>亲爱的作者，请在投稿邮件中添加如下说明告知审稿人共同更新稿件状态哦！</div>
        <div v-clipboard:copy="agreement" v-clipboard:success="onCopy" v-clipboard:error="onError" class="copydiv">点此一键复制</div>
        <div class="auditinstructions">
            <div ref="reftopdiv1" class="topdiv1">
              <!-- 亲爱的审稿人：</br>
              您好！提前感谢您就审稿工作付出的辛勤劳动。</br>
              敬请您首先进入如下链接查看稿件状态，以确定是否继续审核：</br>
              <a href="">{{manuscripturl}}</a></br>
              此致</br>
              敬礼！</br>
              正文如下或见附件。</br> -->
               <p>亲爱的审稿人：</p>
               <p style="text-indent: 2em;">您好！提前感谢您就审稿工作付出的辛勤劳动。</p>
               <p style="text-indent: 2em;">敬请您首先进入如下链接查看稿件状态，以确定是否继续审核：</p>
               <p style="text-indent: 2em;"><a :href="manuscripturl">{{manuscripturl}}</a></p>
               <p style="text-indent: 2em;">此致</p>
               <p>敬礼！</p>
               <p>正文如下或见附件。</p>
            </div>
            <div class="bottomdiv1">
                <div>#（审稿须知）</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                manuscriptId:this.$route.query.manuscriptId,
                manuscriptTitle:this.$route.query.manuscriptTitle,
                manuscripturl:this.baseUrl.hbjxym+'/#/pageInfo?manuscriptId='+this.$route.query.manuscriptId,
                agreement:""
            }
        },
         //初始化方法
    mounted() {
      this.agreement = this.$refs.reftopdiv1.innerText;
    },
        methods:{
            onCopy(e){
                this.$Message.success('复制成功，快去粘贴吧！');
                console.log(e);
            },
            onError(e){
                console.log(e);
            },
            copyClick(){
                this.$Message.success('复制成功，快去粘贴吧！');
            }
        }
    }
</script>
<style scoped>
    .topdiv1{
        width: 100%;
        flex: 1;
        line-height: 40px;
        font-size: 16px;
        justify-content: center;
        padding: 15px;
        
        /* text-decoration:underline */
    }
    .bottomdiv1{
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-weight: bold;
        font-size: 22px;
        border-top: 2px solid rgb(22, 22, 22);
       
    }
    .auditinstructions{
        width: 800px;
        height: auto;
        border: 2px solid rgb(22, 22, 22);
        margin-top: 80px;
        border-radius: 3px;
        display: flex;
        flex-direction: column;
        margin-bottom: 50px;
    }
    .copydiv{
        width: 260px;
        height: 80px;
        border: 3px solid rgb(22, 22, 22);
        text-align: center;
        line-height: 80px;
        font-weight: bold;
       font-size: 28px;
       cursor: pointer;
       border-radius: 3px;
       -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
       -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
       box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
       transition: all 0.25s;
    }
    .copydiv:hover {
      animation: copydiv 0.25s;
    }
    @keyframes copydiv {
      0%,
      10%,
      55%,
      90%,
      94%,
      98%,
      100% {
        -webkit-transform: scale(1, 1);
      }

      30% {
        -webkit-transform: scale(1.14, 0.86);
      }

      75% {
        -webkit-transform: scale(0.92, 1.08);
      }

      92% {
        -webkit-transform: scale(1.04, 0.96);
      }

      96% {
        -webkit-transform: scale(1.02, 0.98);
      }

      99% {
        -webkit-transform: scale(1.01, 0.99);
      }
    }
    .shuomin{
        width: 500px;
        height: 150px;
        line-height: 40px;
        margin-top: 50px;
        font-size: 20px;
    }
    .manuscriptId{
        font-weight: bold;
       font-size: 20px;
      margin-top: 50px;
      cursor: pointer;
    }
   .title{
       font-weight: bold;
       font-size: 44px;
       margin-top: 80px;
       margin-bottom: 40px;
   }
  .page {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: auto;
    margin: 5px 0px 5px 0px;
    padding-left: 150px;
    background-color: #fff;
    -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/components/CreateInfoSuccess.vue